
  import { Component, Vue, Prop } from "vue-property-decorator";
  import { namespace } from "vuex-class";
  import LzModal from "@/components/Modal.vue";
  import LzButton from "@/components/Button.vue";
  import { apiWebsite } from "@/modules/web/api";
  import LayoutSelect from "@/components/LayoutSelect.vue";
  import ColorPicker from "@/components/Input/ColorPicker.vue";
  const auth = namespace("auth");

  type Properties = {
    layout: "spaced" | "grid";
    title: string;
    titleColor: string;
    subtitle: string;
    subtitleColor: string;
    background: string;
  };

  @Component({ components: { LzModal, LzButton, LayoutSelect, ColorPicker } })
  export default class DesignModal extends Vue {
    @auth.State("id")
    ongId!: string;

    @auth.State("websiteId")
    websiteId!: string;

    @Prop({ type: String, required: true })
    section!: string;

    visible = false;
    saving = false;
    sectionExists = false;

    properties: Properties = {
      title: "",
      titleColor: "#000000",
      subtitle: "",
      subtitleColor: "#000000",
      background: "#000000",
      layout: "spaced"
    };

    layoutOptions = [
      {
        value: "spaced",
        label: this.$t("projects.read.design.layout.options.spaced")
      },
      {
        value: "grid",
        label: this.$t("projects.read.design.layout.options.grid")
      }
    ];

    openModal() {
      this.visible = true;
    }

    closeModal() {
      this.visible = false;
    }

    save() {
      const sectionBody = {
        websiteId: this.websiteId,
        type: this.section,
        properties: this.properties
      };

      const process = (body: typeof sectionBody) =>
        this.sectionExists
          ? apiWebsite.section.put(this.websiteId, body)
          : apiWebsite.section.post(this.websiteId, body);

      this.saving = true;
      process(sectionBody)
        .then(() => {
          this.$notify({
            text: this.$tc("common.notifications.changeSuccess"),
            type: "success"
          });
        })
        .catch(() => {
          this.$notify({
            text: this.$tc("common.error.generic"),
            type: "error"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }

    async loadSection() {
      try {
        const section = await apiWebsite.section.get<Properties>(
          this.websiteId,
          this.section
        );
        this.properties = { ...this.properties, ...section.properties };
        this.sectionExists = true;
      } catch {
        this.sectionExists = false;
      }
    }

    async mounted() {
      await this.loadSection();
    }
  }
